import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import { Loader, Container, Message, Segment } from "semantic-ui-react";
import "./styles/main.scss";
import "react-datepicker/dist/react-datepicker.css";
import LoggedInContainer from "./components/containers/LoggedInContainer";
import LoggedOutContainer from "./components/containers/LoggedOutContainer";

axios.defaults.baseURL = "/dealer/api";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      user: {},
      loading: true,
      navVisible: true,
      dimmerActive: false,
      navActive: true,
      verified: false,
      error: null,
      isFinancial: false,
    };

    this.onLogin = this.onLogin.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.sessionCheck = this.sessionCheck.bind(this);
    this.fetchProfile = this.fetchProfile.bind(this);
    this.setError = this.setError.bind(this);
  }

  componentDidMount() {
    this.sessionCheck();

    if (window.innerWidth <= 1024) {
      this.setState({
        navActive: false,
      });
    }
  }

  sessionCheck() {
    axios
      .get("/status/")
      .then(({ data }) => {
        if (data.response === false) {
          this.setState({
            loading: false,
            loggedIn: false,
          });
        } else {
          this.setState({
            isFinancial: data.is_financial,
            loading: false,
            loggedIn: true,
            verified: data.verified,
          });
        }
      })
      .catch((err) => this.setError());
  }

  setError() {
    this.setState({
      loading: false,
      error: true,
    });
  }

  fetchProfile() {
    const { loggedIn } = this.state;

    if (loggedIn) {
      axios
        .get("/profile/")
        .then(({ data }) => {
          this.setState({
            isFinancial: data.is_financial,
            loading: false,
            loggedIn: true,
            verified: data.full_access,
          });
        })
        .catch((err) => {
          this.setError();
        });
    }
  }

  onLogin(user) {
    this.setState({
      loggedIn: true,
      user,
    });

    this.fetchProfile();
  }

  onLogout() {
    axios
      .post("/logout/")
      .then((res) => {
        this.setState({
          loggedIn: false,
          user: {},
          loading: true,
          verified: false,
          error: null,
          isFinancial: false,
        });
      })
      .then(() => (document.location = "/dealer/"))
      .catch((err) => console.log(err));
  }

  render() {
    const { loggedIn, user, loading, verified, error } = this.state;

    if (loading) {
      return <Loader active={loading} />;
    }

    if (error) {
      return (
        <Container>
          <Segment>
            <Message
              size="huge"
              header="Error"
              negative
              content="There was a problem. Please try again later."
              icon="exclamation"
            />
          </Segment>
        </Container>
      );
    }

    return (
      <div>
        {loggedIn ? (
          <LoggedInContainer
            // verified={verified}
            verified
            isFinancial={this.state.isFinancial}
            onLogout={this.onLogout}
          />
        ) : (
          <LoggedOutContainer onLogin={this.onLogin} />
        )}
      </div>
    );
  }
}

ReactDOM.render(
  <div>
    <Router>
      <App />
    </Router>
  </div>,
  document.getElementById("app")
);

if (module.hot) {
  module.hot.accept();
}
